import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ProDataManagementService } from '../../../services/pro-data-management.service';

@Component({
  selector: 'app-data-management-show-modal',
  templateUrl: './data-management-show-modal.component.html',
  styleUrls: ['./data-management-show-modal.component.scss']
})
export class DataManagementShowModalComponent implements OnInit {

  show: any;
  season: any;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<DataManagementShowModalComponent>,
              private proDataManagementService: ProDataManagementService) { 
    this.season = data.season;
    // this.show = data.show;
  }

  ngOnInit() {
    console.log(this.season);
    console.log(this.season.episodes);

    this.proDataManagementService.myMethod('parameter').subscribe( (response: any) => {
      console.log(response);
    });

    // console.log(this.show);
    // console.log(this.show.seasons);
  }

  close(): void {
    this.dialogRef.close();
  }

}
